import type { $Fetch } from 'ofetch';
import type { Engajamento } from '@/domain/model/Engajamento';
import type { EngajamentoGateway } from '@/application/port/out/EngajamentoGateway';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

export class HttpEngajamentoGateway implements EngajamentoGateway {
  constructor(private readonly client: $Fetch) {}

  async fetch(matriculaId: string): Promise<Engajamento> {
    const res = await this.client<ApiResponse<Engajamento>>(
      `/api/v1/matriculas/${encodeURIComponent(matriculaId)}/engajamento`,
      { method: 'GET' },
    );
    assertApiSuccess(res);
    return res.data;
  }
}
